import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCountryCityShippingRatesListQuery } from 'api';
import { SpecialRate } from './index';

export const useSpecialRates: any = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [dataToEdit, setDataToEdit] = useState<SpecialRate | undefined>();
  const { id } = useParams() as { id: string };
  const { data: specialRates = [] } = useCountryCityShippingRatesListQuery({ countryId: id });

  const onHandleEdit = useCallback((data: SpecialRate) => {
    setDataToEdit(data);
    setOpenModal(true);
  }, []);
  const onHandleDelete = useCallback((data: SpecialRate) => {
    setDataToEdit(data);
    setIsDeleteModalOpen(true);
  }, []);
  const onDeleteModalClose = useCallback(() => {
    setIsDeleteModalOpen(false);
    setDataToEdit(undefined);
  }, []);
  const onModalStateChange = useCallback(() => {
    setOpenModal((oState) => {
      if (oState) {
        setDataToEdit(undefined);
      }
      return !oState;
    });
  }, []);

  return {
    openModal,
    specialRates,
    onModalStateChange,
    onHandleEdit,
    dataToEdit,
    onHandleDelete,
    isDeleteModalOpen,
    onDeleteModalClose,
  };
};
